// import React from 'react';

// function NoDataComponent(props) {
//     return (
//         <div className='text-center mt-5 mb-5'>
//             <i className="fa-solid fa-list-ul f-20"></i>
//             <p>{props?.message}</p>
//         </div>
//     );
// }

// export default NoDataComponent;

import React from 'react';
import { Card } from 'react-bootstrap';

const NoDataComponent = ({
    title = "No Data Found",
    message = "We couldn't find any records matching your criteria.",
    icon = "fa-folder-open",
    showButton = false,
    buttonText = "Refresh",
    onButtonClick
}) => {
    return (
        <Card className="border-0 shadow-sm text-center py-5 my-3 bg-light bg-opacity-50">
            <Card.Body>
                <div className="mb-4 position-relative d-inline-block">
                    {/* Background Circle */}
                    <div
                        className="rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center"
                        style={{ width: '80px', height: '80px', margin: '0 auto' }}
                    >
                        <i className={`fas ${icon} fa-2x text-muted opacity-50`}></i>
                    </div>
                    {/* Small decorative dot */}
                    <div
                        className="position-absolute bg-warning rounded-circle"
                        style={{ width: '12px', height: '12px', top: '5px', right: '5px' }}
                    ></div>
                </div>

                <h5 className="fw-bold text-dark mb-2">{title}</h5>
                <p className="text-muted mb-4" style={{ maxWidth: '400px', margin: '0 auto' }}>
                    {message}
                </p>

                {showButton && (
                    <button
                        className="btn btn-outline-primary btn-sm px-4 rounded-pill fw-bold"
                        onClick={onButtonClick}
                    >
                        <i className="fas fa-redo me-2"></i>{buttonText}
                    </button>
                )}
            </Card.Body>
        </Card>
    );
};

export default NoDataComponent;